<template>
	<div class="flex flex-col gap-6">
		<h2 class="font-bold text-xl md:text-3xl">Nyheter</h2>
		<ul class="flex flex-col gap-6">
			<li v-for="news in store.news" :key="news.link">
				<a rel="noopener noreferrer" target="_blank" :href="news.link" class="podcast-card flex flex-col hover:opacity-75">
					<span class="text-red text-xs font-bold uppercase leading-5">{{ news.category }}</span>
					<time :datetime="news.date" class="text-xs uppercase leading-5">{{ format(new Date(news.date), 'yyyy-MM-dd HH:mm') }}</time>
					<h3 class="text-lg font-bold leading-tight">{{ news.title }}</h3>
					<p class="line-clamp-2">{{ $sanitize(news.description) }}</p>
				</a>
			</li>
		</ul>
	</div>
</template>

<script setup>
	import { usePodcastStore } from '../stores/podcastStore'
	import { format } from 'date-fns'
	const store = usePodcastStore()
</script>
